import { QueryKeyFactory } from '@shared/api/queries/queryKeyFactory';
import { useMutation } from '@tanstack/react-query';
import { profileApi } from './api';
import { useSmartQuery } from '@shared/api/queries/hooks';

// Add your feature-specific hooks here
export const useProfile = () => {
  // Define your hooks
  return {};
};

export const useConsumerDetail = (
  params: { remote_utility_id: number; consumer_no: string },
  options?: { enabled?: boolean }
) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.login.consumerDetail(params),
    () => profileApi.getConsumerDetail(params),
    {
      refetchInterval: false,
      ...options,
    }
  );
};

export const useMeterList = (params: {
  remote_utility_id: string | number;
  consumer_id: string | number;
  remote_meter_id: string | number;
  is_status: boolean;
  page: any;
  limit: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.profile.meterList(params), 
    () => profileApi.getMeterList(params),
    {
      enabled: !!params.remote_meter_id,
    }
  );
};

export const useContract = (remoteUtilityId: any, contractId?: any) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.profile.contract({ remoteUtilityId, contractId }),
    () => profileApi.getContract({ 
      remoteUtilityId: remoteUtilityId.toString(),
      contractId: Array.isArray(contractId)
        ? contractId.map(id => id?.toString())
        : contractId?.toString(),
    }),
    {
      enabled: !!remoteUtilityId,
    },
  );
};

export const useConsumerDocuments = (
  id: string,
  filters: any = {},
) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.profile.consumerDocuments(id),
    () => profileApi.getDocuments(id, filters),
    {
      enabled: !!id,
      staleTime: 5 * 60 * 1000,
    },
  );
};

export const useUpdateConsumer = () => {
  return useMutation({
    mutationFn: (params: { consumerId: string | number; payload: any }) => 
      profileApi.updateConsumer(params.consumerId, params.payload),
  });
};
